import SchemaTOC from './SchemaTOC'

export default SchemaTOC
